<template>
    <div class="achievements-wrapper">
        <Row :gutter="32">
            <i-col :xs="12">
                <Table ref="achievementTable" :columns="columns" :loading="dataLoading" :data="achievements" :row-class-name="AchievementRowClassName"  @on-row-click="onAchievementRowClick">
                    <div slot-scope="{ row, index }" slot="action">
                        <Button type="error" size="small" @click="deleteAchievement(row,index)">Delete</Button>
                    </div>
                </Table>
            </i-col>
            <i-col :xs="12">
                <div class="add-form">
                    <AchievementForm ref="achievementForm" @getAchievements="getAllAchievements" @setActive="setActive" :achievements="achievements"></AchievementForm>
                </div>
            </i-col>
        </Row>
    </div>
</template>

<script>
    import { bus } from "../../main";
    import { getAchievements, deleteAchievement } from "../../_services/achievement.service";
    import AchievementForm from "./AchievementForm"

    export default {
        components:{
            AchievementForm
        },
        data() {
            return {
                dataLoading:false,
                submitLoading:false,
                activeAchievement:null,
                columns: [
                    {
                        title: "Existing achievements",
                        key: "AchievementName"
                    },
                    {
                        title:" ",
                        slot:"action",
                        align:"right",
                        width: "80"
                    }
                ],
                descColumns: [
                    {
                        title: "Language",
                        key: "LanguageName",
                        className: "capitalize",
                        width:"150"
                    },
                    {
                        title: "Description",
                        key: "Description"
                    },
                    {
                        title:" ",
                        slot:"action",
                        align:"right",
                        width: "80"
                    }
                ],
                achievements:[]
            };
        },
        methods: {
            deleteAchievement(data,index) {
                this.$Modal.confirm({
                    title: 'Remove Achievement',
                    content: "Are you sure you want to remove achievement?",
                    okText: 'Remove',
                    cancelText: 'Cancel',
                    onOk: () => {
                        this.dataLoading = true
                        deleteAchievement(data._id).then(res => {
                            this.achievements.splice(index, 1);
                            this.dataLoading = false
                            this.$refs.achievementForm.resetForm()
                            this.$Message.success(`Successfully deleted achievement ${data.AchievementName}!`);
                        }).catch(err => {
                            this.dataLoading = false
                            this.$Message.error("Failed to remove Achievement. Please try again later.");
                        });
                    },
                });
            },
            getAllAchievements() {
                this.dataLoading=true
                getAchievements().then(res => {
                    this.dataLoading=false
                    this.achievements=res.data.data
                }).catch(err => {
                    this.dataLoading=false
                    bus.$emit('requestError',err)
                    this.$Message.error("Failed to get achievements. Please try again later");

                });
            },
            onAchievementRowClick(data,index){
                if(this.activeAchievement===index){
                    this.activeAchievement=null
                    this.$refs.achievementForm.resetForm()
                }else {
                    this.$refs.achievementForm.setUpdateData(data)
                }
            },
            AchievementRowClassName(row, index) {
                if (index === this.activeAchievement) {
                    return 'active-table-row';
                }
                return '';
            },
            async setActive(data){
                if(!data){
                    this.activeAchievement=null
                }else{
                    let vIndex = this.achievements.map(function(e) { return e._id; }).indexOf(data._id);
                    if(vIndex===-1){
                        this.activeAchievement = null
                    }else {
                        this.activeAchievement = await vIndex
                    }
                }
            },

        },
        mounted() {
            this.getAllAchievements()
        }
    };
</script>
<style scoped>
    .achievements-wrapper{
        width: 1000px;
    }
</style>
